import { IBaseTitleProps } from "../../properties/TitleProperties";

const BaseTitle = ({
  title,
  totalItemCount,
  itemName,
  description,
}: IBaseTitleProps) => {
  return (
    <div className="ttl-wrap">
      <p className="ttl-title">
        {title}
        {totalItemCount && itemName ? (
          <span className="ttl-count">
            {totalItemCount} {itemName}
          </span>
        ) : null}
      </p>
      {description ? <p>{description}</p> : null}
    </div>
  );
};

export default BaseTitle;
